import { SpinProps as AntdSpinProps } from "antd"

export type SpinnerProps = AntdSpinProps & {};

type DefaultSpinnerProps = {};

export const defaultProps: DefaultSpinnerProps = {};
